module.exports = __webpack_public_path__ + "static/media/sample_cha_container_updates.238bd692.csv";